import { NavLink, Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { buttonStyles } from '@lumlab/platform-ui';

export function AdministrationLayout() {
    const { t } = useTranslation();
    return (
        <>
            <nav className="flex flex-wrap gap-3" aria-label={t('tenders.archives.navigation')}>
                <NavLink
                    end
                    to="/admin/products/tenders"
                    className={({ isActive }) => buttonStyles({ variant: isActive ? 'default' : 'ghost' })}
                >
                    {t('tenders.archives.title')}
                </NavLink>
                <NavLink
                    to="/admin/products/tenders/agencies"
                    className={({ isActive }) => buttonStyles({ variant: isActive ? 'default' : 'ghost' })}
                >
                    {t('tenders.navigation.agencies')}
                </NavLink>
                <NavLink
                    to="/admin/products/tenders/analysis"
                    className={({ isActive }) => buttonStyles({ variant: isActive ? 'default' : 'ghost' })}
                >
                    {t('tenders.arbitration.title')}
                </NavLink>
            </nav>
            <Outlet />
        </>
    );
}
